import { useState, useEffect } from "react";
import apiParticipantes from "../api/Participantes/api-participantes";

export const useModalTipos = () => {
  const [codigoPropuesta, setCodigoPropuesta] = useState("");
  const [tipoP, setTipoP] = useState("");
  const [numeroDocumento, setNumeroDocumento] = useState("");

  const actualizarCodigo = async () => {
    if (codigoPropuesta && numeroDocumento && tipoP) {
      let endCode = await apiParticipantes.actualizarTipoP(codigoPropuesta, numeroDocumento, tipoP)
      setTipoP(endCode.data.tipoP)
    }
  };

  useEffect(() => {
  }, [tipoP]);

  return {
    actualizarCodigo,
    setCodigoPropuesta,
    codigoPropuesta,
    tipoP,
    setTipoP,
    numeroDocumento,
    setNumeroDocumento
  };
};
